import React from 'react';
import { Icon } from '@workboard/action-item';
import { t } from 'i18next';
import { ActivityIssueTypes } from '../types/ai.types';
import aiTypeDefinitions from '../../assets/activity_type_definitions.json';

export const getAiTypeDefinitions = () => aiTypeDefinitions

export const getAiTypeAttributes = (type: string | number) => {
  const typeAttribute = wbConfig?.getAITypeAttributes(type) ?? null;
  return typeAttribute ?? {};
};

export const getActivityTypeName = (type: string | number) => {
  const typeDefinitions = getAiTypeAttributes(type);
  return typeDefinitions?.label ?? 'action';
};

export const getStateComponentIcon = (
  values: any[],
  value?: string | number
) => {
  const stateValue = values?.filter((val) => val.value == value);
  return stateValue?.[0]?.icons?.component ?? '';
};

export const getStateObjectLabel = (
  values: any[],
  value?: string | number
) => {
  const stateValue = values?.filter((val) => val.value == value);
  return stateValue?.[0]?.label ?? '';
}

export const getAiTypeAttributeIconName = (
  type: string | number, attrName: string, value: string | number
) => {
  const { attributes } = getAiTypeAttributes(type);
  const findIconObject = attributes?.[attrName]?.values?.find((val) => val.value == value);
  return findIconObject?.icons?.component ?? '';
}

export const getAiTypeActionAttributeIconName = (attrName: string, value: string | number) =>
  getAiTypeAttributeIconName(ActivityIssueTypes.ActionItem, attrName, value);

export const getActionConfig = () => getAiTypeAttributes(ActivityIssueTypes.ActionItem)

export const getAiTypeActionLabel = () => getActionConfig()?.label || t('Action');

export const getAiTypeActionLabelPlural = () => getActionConfig()?.labelPlural || t('Actions');

export const getAiTypeActionIconName = () => getActionConfig()?.icons?.component ?? '';

export const getAiTypeActionAttribute = (name) => getActionConfig()?.attributes[name];

export const getAiTypeActionStateValues = () => getAiTypeActionAttribute('state')?.values || [];

export const getAiTypeActionAttributeValues = (attrName: string) =>
  getAiTypeActionAttribute(attrName)?.values || [];

export const getAiTypeActionStateIcon = (value) =>
  (params = {}) => React.createElement(Icon, {
    ...params,
    name: getStateComponentIcon(
      getAiTypeActionStateValues(),
      value
    ),
  });

export const getAiTypeActionAttributeValueIcon = (attrName: string, value: number) =>
  (params = {}) => React.createElement(Icon, {
    ...params,
    name: getStateComponentIcon(
      getAiTypeActionAttributeValues(attrName),
      value
    ),
  });

export const getActivityIssueTypesFilterOptions = () => {
  const issueTypes = getAiTypeDefinitions();
  return issueTypes.map((type) => ({
    id: String(type.id),
    title: type.label,
    icons: {
      component: type.icons.component,
    },
  }));
};
